import { Box, Link } from "@mui/material";
import { TOS_URL, PP_URL } from "config";
import packageInfo from "../../../package.json";

const linkStyle = {
  color: "inherit",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
};

export default function CopyRight() {
  return (
    <Box sx={{ padding: "16px", fontSize: "12px", lineHeight: "1.3" }}>
      <Box>
        <span>©2025 Xylo Risk, Inc.</span>
        <span>v{packageInfo.version}</span>
      </Box>
      <Box sx={{ display: "flex", gap: "16px" }}>
        <Link href={TOS_URL} target="_blank" sx={linkStyle}>
          Terms of Service
        </Link>
        <Link href={PP_URL} target="_blank" sx={linkStyle}>
          Privacy Policy
        </Link>
      </Box>
    </Box>
  );
}
